export const mail = {
  subject: "Let's connect",
  body: "Hey Siddharth,\b I visited your portfolio.",
};
